import {Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

import {FieldConfig} from '../../../models/form-config.model';
import {CustomInput} from '../../../../../widgets/custom-input/custom-input';


/**
 * TextField — wrapper del componente CustomInput esistente.
 *
 * Gestisce i tipi: text, number, email, tel, date.
 * Passa il FormControl direttamente a CustomInput tramite @Input() control.
 */
@Component({
  selector: 'app-text-field',
  standalone: true,
  imports: [ReactiveFormsModule, CustomInput],
  template: `
    <app-custom-input
      [label]="field().label"
      [type]="field().type"
      [showIcon]="!!field().icon"
      [iconSource]="field().icon ?? ''"
      [placeholder]="' '"
      [control]="control()"
      [required]="field().required ?? false"
      [class.has-error]="control().invalid && control().touched"
    />
  `,
  styles: [`
    :host { display: block; width: 100%; }
  `],
})
export class TextFieldComponent {
  field = input.required<FieldConfig>();
  control = input.required<FormControl>();
}
